import wx from "weixin-js-sdk";
import { getShareConfig} from "../api/interface";
import { reactive } from "vue";
let url = window.location.href.split("#")[0];
// 扫码
export function getShareCon() {
  const info = reactive({
    is_mask: false,
    title: "享梦游旅行",
    desc: "全国领先的社交旅行种草平台",
    link: "",
    imgUrl:
      "https://resource.xmy.club/wxsmall/images/cover.jpg"
  });
  getShareConfig({ url: url }).then(res => {
    console.log('分享配置', res);
    info.link = res.url
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.appid, // 必填，公众号的唯一标识
      timestamp: parseInt(res.timestamp), // 必填，生成签名的时间戳
      nonceStr: res.noncestr, // 必填，生成签名的随机串
      signature: res.signature, // 必填，签名，见附录1
      jsApiList: ["updateAppMessageShareData", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });
  });
  const getShareContentFun = () => {
    // getShareContent(data).then(res => {
    //   if (+res.code === 0) {
    //     info.title = res.data.title;
    //     info.link = res.data.link;
    //     info.desc = res.data.desc;
    //     info.imgUrl = res.data.img;
    //     localStorage.setItem("share_img", res.data.poster_img);
    //   }
    // });
    wx.updateAppMessageShareData({
      title: info.title, // 分享标题
      desc: info.desc, // 分享描述
      link: info.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: info.imgUrl, // 分享图标
      success: function() {
        // 设置成功s
        console.log("设置成功2", info.link);
      }
    });
  };
  wx.ready(() => {
    wx.updateAppMessageShareData({
      title: info.title, // 分享标题
      desc: info.desc, // 分享描述
      link: info.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: info.imgUrl, // 分享图标
      success: function() {
        // 设置成功s
        console.log("设置成功", info.link);
      }
    });
  });
  // 处理错误情况
  wx.error(function(res){
    // 处理失败验证
    console.log(res.errMsg);
  });
  return {
    info,
    getShareContentFun,
  };
}
